module.exports = __webpack_public_path__ + "img/right-7.89599698.png";